import { MasterDialog } from "#common/Dialog/Dialog"
import InputNumber from "#common/input/InputNumber"
import { useApiSend } from "#hooks/useApiSend"
import { jobProfileKpisPost } from "#job-profile/services/api"
import { Box, Button, TextField } from "@mui/material"
import Grid2 from "@mui/material/Unstable_Grid2"
import { useCallback, useMemo, useState } from "react"
import { toast } from "react-toastify"
import { JobProfileKpisTable } from "./JobProfileKpisTable"

const kpiDefault = {
	name: "",
	description: "",
	minimum_percentage: null,
}

/**
 * @description Componente formulario  para agregar un KPI
 * @param {{onClick: (data: JobProfileKpisGetType) => void}} param0
 * @returns {JSX.Element}
 */
export default function JobProfileKpisForm({ value, setValues }) {
	// const [kpi, setKpi] = useState(kpiDefault)

	const fields = (name) => {
		// if (value === undefined || setValues === undefined) return {}
		return {
			value: value[name],
			onChange: (event) =>
				setValues((oldData) => ({ ...oldData, [name]: event.target.value })),
		}
	}

	return (
		<Grid2 container spacing={2} alignItems="center" width={"100%"}>
			<Grid2 xs={12}>
				<TextField label={"Nombre"} {...fields("name")} fullWidth />
			</Grid2>
			<Grid2 xs={12}>
				<TextField
					label={"Descripción"}
					{...fields("description")}
					multiline
					rows={2}
					fullWidth
				/>
			</Grid2>
			<Grid2 xs={12}>
				<InputNumber label={"% Mínimo"} {...fields("minimum_percentage")} fullWidth />
			</Grid2>
		</Grid2>
	)
}

function validatedKpi(kpi) {
	if (kpi.name === "") {
		toast.error("El nombre es obligatorio")
		return false
	}
	if (kpi.description === "") {
		toast.error("La descripción es obligatoria")
		return false
	}
	if (kpi.minimum_percentage === null) {
		toast.error("El % mínimo es obligatorio")
		return false
	}
	const percentage = parseInt(kpi.minimum_percentage)
	if (percentage > 100 || percentage < 0) {
		toast.error("El % mínimo debe ser un número entre 0 y 100")
		return false
	}
	return true
}

/**
 * @description Componente para agregar un KPI al momento de crear un perfil puesto
 */
export const JobProfileKpisFormList = ({ value, setValue }) => {
	const [kpi, setKpi] = useState(kpiDefault)

	const onDelete = (kpi) => {
		setValue(
			value.filter((item) => {
				return item.name !== kpi.name
			})
		)
	}

	const handlerAdd = () => {
		if (!validatedKpi(kpi)) return
		if (value.find((item) => item.name === kpi.name)) {
			toast.error("Ya existe un KPI con ese nombre")
			return
		}
		setValue([...value, kpi])
		setKpi(kpiDefault)
	}

	return (
		<Box display={"flex"} flexDirection={"column"} gap={1} alignItems={"center"}>
			<JobProfileKpisForm value={kpi} setValues={setKpi} />
			<Button onClick={handlerAdd}>Agregar</Button>
			<JobProfileKpisTable data={value} onDelete={onDelete} />
		</Box>
	)
}

export const JobProfileKpisFormDialog = ({ profileId, open, setOpen, refresh }) => {
	const [kpi, setKpi] = useState(kpiDefault)
	const [disabled, setDisabled] = useState(false)
	const success = () => {
		refresh()
		setOpen(false)
	}
	const end = () => {
		setDisabled(false)
	}
	const { fetch } = useApiSend(jobProfileKpisPost, { success, end })

	const handlerClose = useCallback(() => {
		setOpen(false)
		setKpi(kpiDefault)
	}, [setOpen])
	const handler = useCallback(() => {
		if (!validatedKpi(kpi)) return
		setDisabled(true)
		fetch(profileId, kpi)
	}, [kpi, fetch, profileId])

	const buttons = useMemo(
		() => [
			{
				label: "Cancelar",
				onClick: handlerClose,
				disabled: disabled,
			},
			{
				label: "Agregar",
				onClick: handler,
				disabled: disabled,
			},
		],
		[disabled, handler, handlerClose]
	)

	return (
		<MasterDialog
			{...{ open, setOpen, buttons, title: "Agregar KPI", closeDialog: handlerClose }}
		>
			<JobProfileKpisForm
				dialog
				setValues={setKpi}
				value={kpi}
				onClick={(data) => fetch(profileId, data)}
			/>
		</MasterDialog>
	)
}
